// extracted by mini-css-extract-plugin
export default {"View":"View_View__9+1yN"};